// import React, { useEffect, useState } from 'react'
// import { useContext } from 'react';
// import { AppContext } from '../../App';
// import { useNavigate } from 'react-router-dom';
// import { Link } from 'react-router-dom';
// import { AiOutlineLeft } from 'react-icons/ai';
// import { AiOutlineRight } from 'react-icons/ai';

// import './products.css'
// const Products = () => {
//     const {route ,setLoader ,imgRoute}=useContext(AppContext)
//     const [product,setProduct]=useState([])
//     const [imgIndex,setImgIndex]=useState(0)
//     const history =useNavigate()
//     const [productId,setProductId]=useState("")
// const clickArrow =(side ,length , prId)=>{
//     setProductId(prId)
// if(side === "right"){
//     if(imgIndex < length-1){
// setImgIndex(imgIndex+1)
//     }
//     else{
//         setImgIndex(0)
//     }
// }
// else if(side === "left"){
//     if(imgIndex === 0){
//         setImgIndex(length-1)
//     }
//     else{

//         setImgIndex(imgIndex-1)
//     }
// }
// }

//     useEffect(()=>{
//         fetch(`${route}/product`)
//         .then(res=>res.json())
//         .then(data=>{
//           if(data.data){
//            console.log(data.data)
//             setProduct(data.data)
//           }
//         })
//       },[])
//   return (
//    <div className="products">
//     <div className="container">
//        <h2> الدورات التخصصية</h2>
//        <div className="pro-cards">
      
//             {product.map((pr,index)=>{
//                 return(
//                     <div className="pr-card" key={index}>
//                         <div className="title">{pr.title}</div>
//                         <div className="img">
//                            <AiOutlineLeft onClick={()=>clickArrow("left" , pr.images.length ,pr.id)} />
//                             {pr.images.map((img,index)=>{
//                             if(pr.id === productId){
//                                     if(index === imgIndex){
                                
//                                         return(
//                                             <img data-aos="fade-right" src={`${imgRoute}/${img.image}`} />
//                                         )
//                                     }
//                                 }
//                            else if(index === 0){
                                
//                                 return(
//                                     <img data-aos="fade-right" src={`${imgRoute}/${img.image}`} />
//                                 )
//                             }
//                         })}
//                         <AiOutlineRight onClick={()=>clickArrow("right" , pr.images.length ,pr.id)} />
//                         </div>
                   
//                         <div className="desc">{pr.desc}</div>
//                         <div className="price">{pr.price}</div>
//                     </div>
//                 )
//             })}
//         </div>

//     </div> 
//        </div>
   
//   )
// }

// export default Products
import React, { useEffect, useState, useContext } from "react";
import { AppContext } from "../../App";
import { AiOutlineLeft, AiOutlineRight } from "react-icons/ai";
import "./products.scss";

const SkeletonCard = () => (
  <div className="pr-card skeleton">
    <div className="sk-img"></div>
    <div className="sk-line"></div>
    <div className="sk-line small"></div>
  </div>
);

const Products = () => {
  const { route, imgRoute } = useContext(AppContext);
  const [products, setProducts] = useState([]);
  const [imgIndexes, setImgIndexes] = useState({});
  const [loading, setLoading] = useState(true);

  const clickArrow = (side, length, prId) => {
    setImgIndexes((prev) => {
      const current = prev[prId] ?? 0;
      if (side === "right") {
        return { ...prev, [prId]: current < length - 1 ? current + 1 : 0 };
      } else {
        return { ...prev, [prId]: current === 0 ? length - 1 : current - 1 };
      }
    });
  };

  useEffect(() => {
    fetch(`${route}/product` , {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${sessionStorage.getItem("token")}`
      }
    })
      .then((res) => res.json())
      .then((data) => {
        setProducts(data.data || []);
        setLoading(false);
      });
  }, []);

  return (
    <div className="products-page">
      <div className="products-container">
        <h2>الدورات التخصصية</h2>

        <div className="products-grid">
          {loading
            ? Array.from({ length: 6 }).map((_, i) => (
                <SkeletonCard key={i} />
              ))
            : products.map((pr) => {
                const index = imgIndexes[pr.id] ?? 0;

                return (
                  <div className="pr-card" key={pr.id}>
                    <h3>{pr.title}</h3>

                    {/* <div className="img-box">
                      <AiOutlineLeft
                        onClick={() =>
                          clickArrow("left", pr.images.length, pr.id)
                        }
                      />

                      <img
                        src={`${imgRoute}/${pr.images[index]?.image}`}
                        alt={pr.title}
                      />

                      <AiOutlineRight
                        onClick={() =>
                          clickArrow("right", pr.images.length, pr.id)
                        }
                      />
                    </div> */}
     <div className="img-box">
  <button
    className="arrow left"
    onClick={() => clickArrow("left", pr.images.length, pr.id)}
  >
    <AiOutlineLeft />
  </button>

  <img src={`${imgRoute}/${pr.images[index]?.image}`} alt={pr.title} />

  <button
    className="arrow right"
    onClick={() => clickArrow("right", pr.images.length, pr.id)}
  >
    <AiOutlineRight />
  </button>

  <span className="price-badge">{pr.price} ج</span>
</div>



                    <p className="desc">{pr.desc}</p>
                    {/* <div className="price">{pr.price}</div> */}
                  </div>
                );
              })}
        </div>
      </div>
    </div>
  );
};

export default Products;
